import { cssVars } from '@/app/styles';

export const MONTH_WIDTH_PX = 800;
export const MONTH_TITLE_HEIGHT = '30px';
const MONTH_SEPARATION_PADDING_PX = 3;
export const MONTH_SEPARATION_PADDING_HALF = `${
  MONTH_SEPARATION_PADDING_PX / 2
}px`;
export const MONTH_SEPARATION_HEADER_PADDING_PX = MONTH_SEPARATION_PADDING_PX;
export const MONTH_SEPARATION_HEADER_PADDING_HALF_PX =
  MONTH_SEPARATION_HEADER_PADDING_PX / 2;
export const MONTH_SEPARATION_HEADER_PADDING_HALF = `${MONTH_SEPARATION_HEADER_PADDING_HALF_PX}px`;
export const SEPARATOR_HEIGHT = '5px';
export const SWIMLANE_LABEL_PADDING_TOP = '5px';
export const SWIMLANE_LABEL_PANE_WIDTH_PX = 110;
export const SWIMLANE_LABEL_PANE_WIDTH = `${SWIMLANE_LABEL_PANE_WIDTH_PX}px`;
export const REVIEWER_IMAGE_BASE_STYLE = `
  height: 60px;
  width: 60px;
`;

export const MONTH_CONTENT_BOTTOM_SIDE_BORDER_COLOR =
  cssVars.propertyHistoryColors.monthContentSeparatorColor;

export const GANTT_TIMELINE_VERTICAL_PADDING_PX = 2.5;

export const MONTH_DATE_STRING_FORMAT = 'YYYY-MM-DD';
